/**
 * [MCV-1812] True when `uploadedAt` falls on the viewer's current LOCAL calendar day (not "within
 * 24 hours"). The API sends `uploaded_at` (a timestamptz) as an ISO string; a string without an
 * offset is read as local time, the same way the Documents grid's "Uploaded At" column shows it.
 * A missing or unparseable timestamp is never "today".
 */
export const isUploadedToday = (
  uploadedAt: string | null | undefined,
  now: Date = new Date()
): boolean => {
  if (!uploadedAt) return false;
  const uploaded = new Date(uploadedAt);
  if (Number.isNaN(uploaded.getTime())) return false;
  return (
    uploaded.getFullYear() === now.getFullYear() &&
    uploaded.getMonth() === now.getMonth() &&
    uploaded.getDate() === now.getDate()
  );
};
